(function () {
  function init() {
    const infoContainer = document.querySelector('.product__info-container');
    if (!infoContainer) return;

    const sales = infoContainer.dataset.sales;
    if (!sales || parseInt(sales, 10) < 100) return;

    const num = parseInt(sales, 10);
    const label = Number.isNaN(num) ? sales : num.toLocaleString() + '+';

    let badge = document.getElementById('sales-badge');
    if (!badge) {
      badge = document.createElement('div');
      badge.className = 'sales-badge';
      badge.id = 'sales-badge';
      badge.innerHTML =
        '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
        '<circle cx="9" cy="21" r="1"></circle>' +
        '<circle cx="20" cy="21" r="1"></circle>' +
        '<path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>' +
        '</svg>';
      const text = document.createElement('span');
      text.className = 'sales-badge__text';
      text.textContent = label + ' ordered from QC Supply';
      badge.appendChild(text);
    }

    const ratingWrapper = document.querySelector('.rating-wrapper');
    const priceWrapper = document.querySelector('.price-wrapper');
    if (!ratingWrapper || !priceWrapper) return;

    const mq = window.matchMedia('(max-width: 749px)');

    function placeBadge() {
      if (mq.matches) {
        if (badge.parentElement !== ratingWrapper) ratingWrapper.append(badge);
      } else if (
        badge.previousElementSibling !== priceWrapper ||
        badge.parentElement !== priceWrapper.parentElement
      ) {
        priceWrapper.after(badge);
      }
    }

    placeBadge();
    mq.addEventListener('change', placeBadge);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
